import { useRouter } from 'next/router'

const useI18nPath = () => {
  const router = useRouter()
  const urlRegex = /^\//

  const getHrefLang = (href: string) => {
    return urlRegex.test(href)
      ? router.query?.lang
        ? `/${router.query?.lang}${href}`
        : href
      : href
  }

  return { getHrefLang }
}

export default useI18nPath
